module.exports = __webpack_public_path__ + "static/media/snippet.66a9875e.png";